import { z } from "zod";

export const LOCALSTORAGE_KEY = "UNIDECK__";

export const Numerals = {
  ones: [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
  ],
  teens: [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ],
  tens: [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ],
};

const generalBackground = `bg-card/50 p-4 text-card-foreground shadow-lg backdrop-blur`;
const generalBorder = `border border-border/50`;
const elementWrapper = `h-full w-full rounded-xl ${generalBackground} ${generalBorder}`;

export const classes = {
  generalBackground,
  generalBorder,
  elementWrapper,
};

export const gradients = [
  "linear-gradient(to top left,#f953c6,#b91d73)",
  "linear-gradient(to top left,#ee0979,#ff6a00)",
  "linear-gradient(to top left,#F00000,#DC281E)",
  "linear-gradient(to top left,#00c6ff,#0072ff)",
  "linear-gradient(to top left,#0ba360,#3cba92)",
  "linear-gradient(to top left,#000000,#434343)",
  "linear-gradient(to top left,#09203f,#537895)",
  "linear-gradient(to top left,#AC32E4,#7918F2,#4801FF)",
  "linear-gradient(to top left,#8a2be2,#0000cd,#228b22,#ccff00)",
  "linear-gradient(to top left,#40E0D0,#FF8C00,#FF0080)",
  "linear-gradient(to top left,#fcc5e4,#fda34b,#ff7882,#c8699e,#7046aa,#0c1db8,#020f75)",
];

export const noteVaultFormSchema = z.object({
  name: z.string().min(1),
});

export const notebookFormSchema = z.object({
  title: z.string().min(1),
  icon: z.string().min(1).nullable(),
  vaultId: z.string().min(1).nullable(),
});

export const noteFormSchema = z.object({
  title: z.string().min(1),
  icon: z.string().min(1),
  content: z.record(z.any()),
  tags: z.array(z.string()).min(1),
  notebookId: z.string().min(1),
});
